var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMailActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C2.24 10 0 12.23 0 15C0 17.77 2.24 20 5 20C7.76 20 10 17.76 10 15C10 12.24 7.77 10 5 10ZM2.95999 12.96H5C5.38 12.96 5.67999 13.27 5.67999 13.64C5.67999 14.01 5.37 14.32 5 14.32H2.95999C2.57999 14.32 2.28 14.01 2.28 13.64C2.28 13.27 2.57999 12.96 2.95999 12.96ZM7.04001 17.04H2.95001C2.57001 17.04 2.26999 16.73 2.26999 16.36C2.26999 15.99 2.58001 15.68 2.95001 15.68H7.04001C7.42001 15.68 7.72 15.99 7.72 16.36C7.72 16.73 7.42001 17.04 7.04001 17.04Z",
    fill: "#007AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16 0H6C3 0 1 1.5 1 5V8.14C1 8.87 1.75001 9.32999 2.42001 9.03999C3.52001 8.55999 4.76999 8.38 6.07999 8.59C8.69999 9.02 10.84 11.09 11.37 13.69C11.52 14.45 11.54 15.19 11.44 15.9C11.36 16.49 11.84 17.01 12.43 17.01H16C19 17.01 21 15.51 21 12.01V5.00999C21 1.49999 19 0 16 0Z",
    fill: "#007AFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.86997C10.16 8.86997 9.31 8.60997 8.66 8.07997L5.52999 5.57997C5.20999 5.31997 5.15 4.84997 5.41 4.52997C5.67 4.20997 6.13998 4.14997 6.45998 4.40997L9.58999 6.90997C10.35 7.51997 11.64 7.51997 12.4 6.90997L15.53 4.40997C15.85 4.14997 16.33 4.19997 16.58 4.52997C16.84 4.84997 16.79 5.32997 16.46 5.57997L13.33 8.07997C12.69 8.60997 11.84 8.86997 11 8.86997Z",
    fill: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMailActive);
export default __webpack_public_path__ + "static/media/send-mail-active.acf4a7dff1bee0203fc25f5525f8d139.svg";
export { ForwardRef as ReactComponent };